import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/industrias/in-vitro-diagnostics/companion-diagnostics-services")({
  head: () => buildRouteHead("/es/industrias/in-vitro-diagnostics/companion-diagnostics-services", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/industrias/diagnostico-complementario", replace: true });
  },
});
